import { notification } from 'ant-design-vue';
import { h } from 'vue';

import isScreenshot from './is-screenshot';

interface Props {
  message: string;
  type?: 'success' | 'info' | 'warning' | 'error';
  duration?: number;
  placement?:
    | 'top'
    | 'topLeft'
    | 'topRight'
    | 'bottom'
    | 'bottomLeft'
    | 'bottomRight';
}

export default function notify({
  message,
  type = 'info',
  duration = 6000,
  placement = 'top',
}: Props) {
  if (isScreenshot()) {
    return;
  }

  notification.destroy();

  const icon = {
    success: h('img', {
      src: '/images/circle-check-icon.svg',
    }),
    info: undefined,
    warning: h('img', {
      src: '/images/alert-triangle.svg',
    }),
    error: h('img', {
      src: '/images/x-square-contained.svg',
    }),
  }[type];

  notification.open({
    class: `beconfident-notification beconfident-notification-${type}`,
    icon,
    placement,
    type,
    message,
    duration: duration / 1000,
  });
}
